module.exports = __webpack_public_path__ + "static/w-bocajetslacrosse-e181b0e7be4abc1887b774b9d0b3cd4b.webp";